/**
 * Copyright (c) 2026, CYBRA Corp.
 */
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { DataMappingService, DataMappingHeaderDto } from 'app/services/data-mapping.service';

@Injectable()
export class DataMappingHdrResolver
    implements Resolve<DataMappingHeaderDto[]> {

    constructor(
        private service: DataMappingService
    ) { }

    async resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Promise<DataMappingHeaderDto[]> {

        try {
            return await this.service.getAllHeaders();
        } catch (error) {
            console.error('Problem resolving Data Mapping Headers', error);
            return [];
        }
    }
}
